import { render, staticRenderFns } from "./DecoratorState.vue?vue&type=template&id=155a1c9b&scoped=true&"
import script from "./DecoratorState.vue?vue&type=script&lang=js&"
export * from "./DecoratorState.vue?vue&type=script&lang=js&"
import style0 from "./DecoratorState.vue?vue&type=style&index=0&id=155a1c9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155a1c9b",
  null
  
)

export default component.exports